<template>
  <div
    class="h5-cart"
    :style="isLoading ? 'padding: 12px 0px 0px 0px;' : ''"
  >
    <div class="cart-header-container">
      <div class="cart-header">
        <div class="cart-header-title">
          Carts
          <span
            class="cart-nums"
            :style="{ opacity: list.length }"
          >{{
            cartCount > 99 ? '99+' : cartCount
          }}</span>
          <SvgIcon
            class="cart-header-batch-delete"
            v-if="renderBatchDelete && !isCartsGuide"
            @click="handleBatchDelete"
            :svg="deleteSvg"
            width="20px"
            height="20px"
            color="#232323"
          />
        </div>
        <div class="cart-header-btn">
          <img
            src="@/assets/images/close-icon.svg"
            alt=""
            class="cart-header-close"
            @click="closeBtn"
          >
        </div>
      </div>
    </div>
    <div>
      <div
        class="cart-empty"
        v-if="isEmpty && !isLoading"
      >
        <CartEmpty />
        <CouponBanner v-if="coupon" />
        <BottomSafeCards />
      </div>
      <div
        v-else
        class="cart-main"
        :style="{ overflow: isCartsGuide && 'hidden' }"
        ref="cartMain"
      >
        <div class="cart-content-main">
          <div class="cart-content">
            <div class="cart-content-carousel">
              <CartCarousel />
            </div>
            <div
              ref="mainTabRef"
              class="cart-content-main-tabs"
            >
              <div
                v-for="(tabName, index) in tabNameList"
                :key="index"
                class="cart-content-main-tabs-item"
                :class="{ active: checkedTabIndex === index }"
                @click="handleCheckedTab(index, tabName)"
              >
                {{ tabName }}
              </div>
            </div>
            <div
              v-if="isLoading"
              class="tab-loading"
            >
              <img
                src="@/assets/H5/empty.gif"
                alt=""
              >
            </div>
            <div
              v-else
              class="cart-center"
            >
              <div
                class="cart-item"
                v-for="(item, index) in list"
                :key="index"
                :style="{
                  marginTop: index === 0 ? '12px' : '0',
                }"
                :class="{ 'cart-item-processing': item.cartStatus === 0 }"
              >
                <SwipeCell
                  @edit="handleEdit(item)"
                  :style="getStyle(index)"
                >
                  <div class="cart-item-main">
                    <div class="cart-item-left">
                      <div class="cart-item-left-checkbox">
                        <img
                          v-if="isUnavailable(item.cartStatus)"
                          :src="disabledCheck"
                          alt=""
                        >
                        <template v-else>
                          <img
                            src="https://cdn-image.bestdealer.com/app-bestdealer/1688/carts/h5-unchecked-icon.svg"
                            alt=""
                            v-if="!item.checked"
                            @click="handleCheck(item)"
                          >
                          <img
                            src="https://cdn-image.bestdealer.com/app-bestdealer/1688/carts/h5-checked-icon.svg"
                            alt=""
                            v-if="item.checked"
                            @click="handleCheck(item)"
                          >
                        </template>
                      </div>
                      <Image
                        :src="item.skuImage"
                        alt=""
                        :style="{ opacity: isUnavailable(item.cartStatus) ? '.4': 1 }"
                        class="cart-center-main-img"
                        @loading-click.stop
                        @click="onImageClick(item.skuImage)"
                      />
                    </div>
                    <div class="cart-item-right">
                      <div class="cart-item-right-top">
                        <div
                          :style="{ color: isUnavailable(item.cartStatus) ? '#b2b7c2' : '#232323' }"
                          class="cart-item-price"
                        >
                          <span>{{ currencyData?.targetCurrency?.slice(0, 2) }}&nbsp;</span>
                          <span>{{ currencyData?.targetUnit }}</span>
                          <span>{{ bankersRound(currencyData?.rate * item?.skuPriceRmb, 2) }}</span>
                        </div>
                        <div
                          v-if="item.cartStatus === 0"
                          @click.stop="showProcessingTips = true"
                          class="cart-item-right-top-processing"
                        >
                          Processing
                          <SvgIcon
                            :svg="rightArrowSvg"
                            color="#DB7E25"
                            width="12px"
                            height="12px"
                          />
                        </div>
                      </div>
                      <div
                        :style="{ color: isUnavailable(item.cartStatus) ? '#b2b7c2' : '#5c5c5c' }"
                        class="cart-item-title"
                        @click="handleSub(item, index)"
                      >
                        {{ item.spuName }}
                      </div>
                      <div
                        class="cart-item-sku"
                        v-for="(skuSpec, index) in item.skuSpec?.split(';') ||
                          ''"
                        :key="index"
                        :style="{ marginTop: index === 1 ? '2px' : '6px', color: isUnavailable(item.cartStatus) ? '#b2b7c2' : '#6E717A' }"
                      >
                        <span class="cart-item-type">{{
                          skuSpec.replace(/:/g, ": ")
                        }}</span>
                      </div>
                      <div class="cart-item-checknum">
                        <div class="secondAttributes-btn">
                          <div
                            class="secondAttributes-btn-sub"
                            @click="attributesSub(item, index)"
                          >
                            <img
                              v-if="isUnavailable(item.cartStatus) || item.skuQuantity <= item.bundleQuantity"
                              :src="IMAGES.irreducible"
                              alt=""
                            >
                            <img
                              v-else
                              :id="'secondAttributes-btn-sub-' + index"
                              :src="
                                item.skuQuantity > 1 &&
                                  (!item.checked ||
                                    getSpuQuantity(item.spuId) >
                                    getSpuBatchNum(item.spuId))
                                  ? item.cartStatus === 0
                                    ? processingImg
                                    : secondAttributesBtnReduce
                                  : IMAGES.irreducible
                              "
                              alt=""
                            >
                            <img
                              v-if="item.cartStatus === 0"
                              src="@/assets/H5/carts/processing-sub-1.svg"
                              alt=""
                              class="secondAttributes-btn-reduce-processing"
                            >
                          </div>
                          <input
                            class="secondAttributes-btn-input"
                            :class="{
                              'secondAttributes-btn-input-error':
                                getSpuBatchNum(item.spuId) >
                                getSpuQuantity(item.spuId) && item.checked,
                              'secondAttributes-btn-input-processing':
                                item.cartStatus === 0,
                            }"
                            :style="{ color: isUnavailable(item.cartStatus) ? '#b2b7c2' : '#232323' }"
                            @change="(e) => changeAttributes(item, index, e)"
                            v-model.number="item.skuQuantity"
                          >
                          <div
                            class="secondAttributes-btn-add"
                            @click="attributesAdd(item, index)"
                          >
                            <img
                              v-if="isUnavailable(item.cartStatus)"
                              :id="'secondAttributes-btn-add-' + index"
                              :src="IMAGES.cannotBeAdded"
                              alt=""
                            >
                            <img
                              v-else
                              :id="'secondAttributes-btn-add-' + index"
                              :src="
                                item.skuQuantity < item.max
                                  ? secondAttributesBtnAdd
                                  : IMAGES.cannotBeAdded
                              "
                              alt=""
                            >
                          </div>
                        </div>
                        <div class="cart-item-checknum-right">
                          <div
                            class="cart-item-checknum-subTitle"
                            :style="{ color: isUnavailable(item.cartStatus) ? '#b2b7c2' : '#5c5c5c' }"
                          >
                            Subtotal:
                          </div>
                          <div class="cart-item-checknum-subTotal">
                            <IntlCurrency
                              :count="
                                (
                                  bankersRound(
                                    currencyData?.rate * item.skuPriceRmb,
                                    2
                                  ) * item.skuQuantity
                                ).toFixed(2)
                              "
                              :size="14"
                              :currency="
                                currencyData?.targetCurrency.slice(0, 2)
                              "
                              :color="subTotalColor(item.cartStatus)"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="item.unavailableMsg"
                        class="unavailableMsg"
                      >
                        {{ item.unavailableMsg }} <span @click="skipThirdPage">Contact us</span>
                      </div>
                    </div>
                  </div>
                </SwipeCell>
                <div
                  class="cart-item-remark"
                  v-if="
                    (getSpuBatchNum(item.spuId) > getSpuQuantity(item.spuId) &&
                      getSpuQuantity(item.spuId) > 0 ) && !item.unavailableMsg
                  "
                >
                  The minimum order quantity of
                  {{ getSpuBatchNum(item.spuId) }} items has not been met.
                </div>
                <div
                  class="cart-item-line"
                  v-if="index !== list.length - 1"
                />
                <div
                  v-if="isCartsGuide && !index"
                  :class="[
                    {
                      'mask-cart-item-1': step === 2,
                    },
                    'mask-cart-item',
                  ]"
                  :style="{ height: cartItemMainHeight }"
                >
                  <img
                    src="@/assets/H5/carts/mark-checked.svg"
                    alt=""
                    class="mask-cart-item-checked"
                    v-if="step === 1"
                  >
                  <img
                    src="@/assets/H5/carts/mask-handle.svg"
                    alt=""
                    class="mask-cart-item-handle"
                    v-if="step === 2"
                  >
                </div>
              </div>
              <div
                v-if="!list.length"
                class="tab-empty"
              >
                <img
                  src="@/assets/illus/empty-tab.svg"
                  alt=""
                >
                It is empty here :-(
              </div>
              <div
                class="cart-mask-step-1"
                v-if="step === 1 && isCartsGuide"
              >
                <div class="step-label">
                  Click here to select items you want to add to checkout or
                  delete.
                </div>
                <div class="step-tool">
                  <div @click="skip">
                    Skip
                  </div>
                  <div @click="step = 2">
                    Next (1/2)
                  </div>
                </div>
                <img
                  src="@/assets/H5/carts/tool-tips.svg"
                  alt=""
                  class="step-tool-1"
                >
              </div>
              <div
                class="cart-mask-step-2"
                v-if="step === 2 && isCartsGuide"
              >
                <div class="step-label step-label-2">
                  Swipe right to delete items you don't want to it.
                </div>
                <div class="step-tool">
                  <div @click="skip">
                    Skip
                  </div>
                  <div @click="skip">
                    Got it
                  </div>
                </div>
                <img
                  src="@/assets/H5/carts/tool-tips.svg"
                  alt=""
                  class="step-tool-2"
                >
              </div>
            </div>
          </div>
          <div style="margin-top: 12px; margin-bottom: 184px">
            <BottomSafeCards :show-payment-methods="true" />
          </div>
        </div>
      </div>
      <AdaptiveIntercomFooter class="cart-pay-container">
        <CouponDetail
          v-if="coupon"
          class="cart-pay-coupon"
          :disabled="!isCouponAvailable"
        />
        <CouponApply
          class="cart-pay-coupon"
          v-else
        />
        <div class="h5-cart-pay">
          <div
            v-if="!showProcessingTips"
            class="cart-pay-subtotal"
          >
            <div class="cart-pay-subtotal-label">
              Subtotal
            </div>
            <div class="cart-pay-subtotal-value">
              <div
                v-if="isCouponAvailable"
                class="cart-pay-subtotal__discount"
              >
                Saved ${{ coupon.discountAmount }}
              </div>
              <IntlCurrency
                :count="isLoading ? '0.00' : renderSubtotal"
                :size="16"
                :currency="currencyData?.targetCurrency.slice(0, 2)"
                color="#ffffff"
              />
            </div>
          </div>
          <div
            v-if="checkedLength && allowOrderSwitch !== 1 && !renderPendingProcessing && !isLoading"
            class="h5-cart-subtotal-tips"
          >
            <img
              src="@/assets/H5/carts/mark-tips.svg"
              alt=""
            >
            <!-- <span>The current order doesn't include shipping costs.</span> -->
            <span>We are a platform dedicated to B2B procurement. Please submit your application to enable the order function.</span>
          </div>
          <div class="checkout-main">
            <div
              class="checkout-radio"
              @click="handleCheckAll"
            >
              <img
                src="@/assets/H5/carts/unchecked-all.svg"
                alt=""
                v-if="!isCheckedAll"
              >
              <img
                src="@/assets/H5/carts/all-checked.svg"
                alt=""
                v-if="isCheckedAll"
              >
              <span class="checkout-radio-label">All</span>
            </div>
            <div
              v-if="isLoading || !checkedLength"
              class="checkout-btn disabled"
            >
              Checkout
            </div>
            <div
              v-else
              class="checkout-btn"
              :class="{ disabled: disabledCheckout }"
              @click="handleCheckout"
            >
              <div v-if="allowOrderSwitch === 1 || inlcudeProcessing">
                Checkout
              </div>
              <template v-else>
                <img
                  src="@/assets/H5/carts/whatsapp-icon.svg"
                  alt=""
                >
                Enable Order Function
              </template>
            </div>
          </div>
        </div>
        <div
          class="processing-tips"
          :style="processingTipsStyle"
        >
          <div class="content">
            <SvgIcon
              @click="showProcessingTips = false"
              class="close-icon"
              :svg="closeSvg"
              color="#ffffff"
            />
            <img
              class="logo"
              src="@/assets/H5/carts/whatsApp-alert.svg"
              alt=""
            >
            <div class="text-1">
              Pending Processing ...
            </div>
            <div class="text-2">
              Your request will be processed within 1 business day. Note: Some items may face customs restrictions in your country. We're verifying clearance status. While waiting, consult our category experts free of charge.
            </div>
            <div
              @click="skipThirdPage"
              class="text-3"
            >
              Free Expert Consultation Now!
            </div>
          </div>
        </div>
        <div
          v-if="whatsAppBottomSheet"
          class="whatsApp-skip-error"
          :style="{
            height: whatsAppBottomSheet ? '380px' : '0',
          }"
        >
          <img
            class="logo"
            src="@/assets/H5/carts/whatsApp-alert.svg"
            alt=""
          >
          <div class="text-1">
            Oops!
          </div>
          <div class="text-2">
            Sorry, if WhatsApp redirect is disabled. Please contact your agent
            directly on WhatsApp at:
          </div>
          <div class="text-2">
            {{ whatsAppNumber }}
          </div>

          <div
            @click="handleCopyLink"
            class="copy-button"
          >
            <img
              src="@/assets/H5/carts/copy-icon.svg"
              alt=""
            >
            CopyLink
          </div>
          <div
            @click="whatsAppBottomSheet = false"
            class="cancel-button"
          >
            Cancel
          </div>
        </div>
      </AdaptiveIntercomFooter>
    </div>
    <div
      class="h5-guide"
      v-if="isCartsGuide"
    >
      <img
        v-if="isCartsGuide"
        src="https://cdn-image.bestdealer.com/app-bestdealer/1688/carts/h5-delete-icon.svg"
        alt=""
        class="cart-header-guide"
      >
      <div
        class="mask-checkout"
        v-if="isCartsGuide && step === 1"
      >
        Checkout
      </div>
    </div>

    <ExceedQuantityDialog 
      v-if="showExceedQuantityDialog"
      @close="handleCloseExceedQuantityDialog"
      :quantity="minOrderQuantity"
    />

    <div
      class="pop-container"
      :class="{ visible: popVisible }"
      @click.stop
    >
      <H5AddressInfo
        v-if="showAddressInfo"
        :handle-close="hiddenPop"
        :current-country="currentCountry"
        :address-type="2"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, onUnmounted, watch, nextTick } from 'vue'
import CartEmpty from './components/CartEmpty/index.vue'
import BottomSafeCards from './components/BottomSafeCards/index.vue'
import SwipeCell from './components/SwipeCell/index.vue'
import CartCarousel from '../CartCarousel/index.vue'
import processingImg from '@/assets/H5/carts/processing-sub.svg'
import closeSvg from '@/assets/H5/home/close.svg?raw'
import rightArrowSvg from '@/assets/offer/right-arrow.svg?raw'
import disabledCheck from '@/assets/H5/carts/disabled-check.svg'
import { useRouter } from 'vue-router'
import { fetchData } from '../../../../utils/fetch'
import {
  bankersRound,
  buriedPointUtil,
  copyText,
  gaAnalytics
} from '../../../../utils/utils'
import { useStore } from 'vuex'
import { usePlugin } from '@/hooks/usePlugin'
import deleteSvg from '@/assets/images/delete-icon.svg?raw'
import CouponBanner from './components/CouponBanner/index.vue'
import CouponDetail from '../CouponDetail/index.vue'
import CouponApply from '../CouponApply/index.vue'
import { useCoupon } from '@/views/Carts/hooks/useCoupon'
import { useCurrency } from '@/hooks/useCurrency'
import AdaptiveIntercomFooter from '@/components/AdaptiveIntercomFooter/index.vue'
import { useUserStore } from '@/pinia/user'
import { useIntercom } from '@/hooks/useIntercom'
import ExceedQuantityDialog from '@/components/H5/ExceedQuantityDialog/index.vue'
import H5AddressInfo from '@/components/H5/H5AddressInfo/index.vue'
import { Image } from '@/components/Image'
import { showImagePreview } from '@/components/ImagePreview'

const { $toast } = usePlugin()

const store = useStore()

const router = useRouter()

const { initCoupon, coupon } = useCoupon()
const { getCurrency, currentCurrency: currencyData, exchangeCurrency } = useCurrency()
const intercom = useIntercom()

const innerHeight = ref(0)
const step = ref(1)
const isLoading = ref(true)
const cartMain = ref(null)

const allowOrderSwitch = ref(0)

const list = ref([])

const isCartsGuide = ref(false)

const whatsAppBottomSheet = ref(false)
const whatsAppUrl = ref('')
const whatsAppNumber = ref('')
const checkedTabIndex = ref(0)

const tabNameList = ref(['All', 'Available', 'Processing', 'Unavailable'])
const mainTabRef = ref(null)

const showProcessingTips = ref(false)

const cartCount = computed(() => store.state.cart.cartCount)

const processingTipsStyle = computed(() => {
  return {
    height: showProcessingTips.value ? '332px' : 0
  }
})

const hasUnavailable = computed(() => {
  const checkedList = list.value.filter(item => item.checked)
  return checkedList.some(item => isUnavailable(item.cartStatus))
})

const checkedLength = computed(() => {
  return list.value.filter(item => item.checked).length
})

const inlcudeProcessing = computed(() => {
  const len = list.value.filter(item => item.checked && item.cartStatus === 0).length
  return len > 0
})

const disabledCheckout = computed(() => {
  const checkedList = list.value.filter(item => item.checked)
  const hasProcessing = checkedList.filter(item => item.cartStatus === 0).length > 0
  const hasUnavailabel = checkedList.filter(item => isUnavailable(item.cartStatus)).length > 0
  return hasProcessing || hasUnavailabel
})

watch(isCartsGuide, (newVal) => {
  if (newVal) {
    document.querySelector('body').classList.add('no-scroll-with-fixed')
  } else {
    document.querySelector('body').classList.remove('no-scroll-with-fixed')
  }
})

const IMAGES = {
  addDefault:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/add_default.svg',
  add: 'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/add.svg',
  reduceDefault:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/reduce_default.svg',
  reduceDefaultProcessing: '@/assets/H5/carts/processing-sub.svg',
  reduce:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/reduce.svg',
  irreducible:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/irreducible.svg',
  cannotBeAdded:
    'https://cdn-image.bestdealer.com/app-bestdealer/1688/icon/cannot_be_added.svg'
}
const secondAttributesBtnAdd = ref(IMAGES.addDefault)
const secondAttributesBtnReduce = ref(IMAGES.reduceDefault)

onBeforeMount(() => {
  initCoupon()
})

onMounted(async () => {
  innerHeight.value = window.innerHeight
  document.querySelector('body').classList.remove('no-scroll')
  gaAnalytics('mp_cart_page_view', 'mp_cart_page_view')
  buriedPointUtil({ eventId: 'MPC501' })
  await getUserInfo()
  await getCurrency()
  await getCarts()
  getCountry()
})

const cartItemMainHeight = computed(() => {
  if (step.value === 2) {
    const cartItemMain = document.querySelector('.cart-item-main')
    if (cartItemMain) {
      return cartItemMain.offsetHeight - 1 + 'px'
    }
  }
  return ''
})

const getUserInfo = async () => {
  const { code, data } = await fetchData('/dsp-app/alibaba-inter/queryMyInfo', {
    method: 'post'
  })
  if (code === 200) {
    allowOrderSwitch.value = data?.allowOrderSwitch
  }
}

// 获取起批量对应价格
const getPriceByQuantity = (quantity, priceRange) => {
  let validPrices = priceRange.filter(item => item.startQuantity <= quantity)
  if (validPrices.length === 0) {
    validPrices = [priceRange[0]]
  }

  const bestMatch = validPrices.reduce((prev, curr) =>
    curr.startQuantity > prev.startQuantity ? curr : prev
  )

  return Number(bestMatch.price)
}

// 更新同级商品下sku价格
const updateProductSkuPrice = (obj) => {
  // 先更新自身
  obj.skuPriceRmb = getPriceByQuantity(obj.skuQuantity, obj.skuPriceCnyRanges)

  // 单个区间下 return
  const skuPriceCnyRanges = obj.skuPriceCnyRanges || []
  if (skuPriceCnyRanges.length < 2) return

  // 获取已选中的同个商品级别下的sku加购总数
  let count = 0
  const checkedList = list.value.filter(v => v.checked)
  const sameProductLevelSku = checkedList.filter(v => v.spuId === obj.spuId)
  sameProductLevelSku.forEach(item => {
    count += item.skuQuantity
  })

  if (count) {
    const skuPriceRmb = getPriceByQuantity(count, obj.skuPriceCnyRanges)
    // 同级sku同步更新金额
    sameProductLevelSku.forEach(item => { item.skuPriceRmb = skuPriceRmb })
  }
}

const getCarts = async (status = null) => {
  try {
    isLoading.value = true
    const url = status ? `/appb/b2b/cart/cartList?page=1&pageSize=200&frontCartStats=${status}` : '/appb/b2b/cart/cartList?page=1&pageSize=200'
    const { code, data } = await fetchData(url)

    if (code === 200) {
      let checkNum = 0
      list.value = data?.rows?.map((v) => {
        if ([0, 10].includes(v.cartStatus) && checkNum < 50) {
          v.checked = true
          checkNum++
        } else {
          v.checked = false
        }
        return {
          ...v,
          max: Infinity
        }
      })

      list.value.forEach(item => {
        updateProductSkuPrice(item)
        item.skuSubtotal = bankersRound(currencyData?.value.rate * item.skuPriceRmb, 2) * item.skuQuantity
      })
      isCartsGuide.value =
        !localStorage.getItem('cartsGuide') && data?.rows.length !== 0
    }
    setTimeout(() => {
      isLoading.value = false
    }, 1000)
    nextTick(() => {
      updateTabsPosition()
    })
  } catch (error) {
    isLoading.value = false
  }
}

const updateTabsPosition = () => {
  const scrollBar = mainTabRef.value
  const activeItem = scrollBar.children[checkedTabIndex.value]
  scrollBar.scrollLeft = activeItem.offsetLeft - scrollBar.clientWidth / 2 + activeItem.clientWidth / 2
}

const handleCheckedTab = (index, tabName) => {
  checkedTabIndex.value = index

  const statusMap = {
    All: null,
    Available: '2',
    Processing: '0',
    Unavailable: '1'
  }
  getCarts(statusMap[tabName])
}

const isEmpty = computed(() => {
  return list.value.length === 0 && checkedTabIndex.value === 0
})

const isCheckedAll = computed(() => {
  return list.value.length > 50
    ? list.value.filter((item) => item.checked).length >= 50
    : list.value.every((item) => item.checked)
})

const handleCheckAll = () => {
  if (checkedTabIndex.value === 3) return
  if (isCheckedAll.value) {
    list.value.forEach((item) => {
      item.checked = false
    })
  } else {
    list.value.forEach((item, index) => {
      item.checked = index < 50
    })
  }
}

const getStyle = (index) => {
  if (isCartsGuide.value && step.value === 2 && index === 0) {
    return { transform: 'translateX(-103px)' }
  }
  return null
}

const renderPendingProcessing = computed(() => {
  return list.value.some((item) => item.cartStatus === 0 && item.checked)
})

const getSpuBatchNum = (spuId) => {
  const spuItems = list.value.filter((item) => item.spuId === spuId)
  return Math.max(...spuItems.map((item) => item.batchNum))
}

const getSpuQuantity = (spuId) => {
  const spuItems = list.value.filter(
    (item) => item.spuId === spuId && item.checked
  )
  return spuItems.reduce((sum, item) => sum + Number(item.skuQuantity), 0)
}

const attributesSub = async (item) => {
  if (isUnavailable(item.cartStatus) || item.skuQuantity <= item.bundleQuantity) return
  if (isCartsGuide.value) {
    return
  }
  const spuQuantity = getSpuQuantity(item.spuId)
  const spuBatchNum = getSpuBatchNum(item.spuId)

  if ((!item.checked || spuQuantity > spuBatchNum) && item.skuQuantity > 1) {
    item.skuQuantity -= item.bundleQuantity
    updateProductSkuPrice(item)

    item.skuSubtotal =
      bankersRound(currencyData?.value.rate * item.skuPriceRmb, 2) *
      item.skuQuantity

    minOrderQuantity.value = item.batchNum

    await updateCarts({
      cartId: item.cartId,
      quantity: item.skuQuantity
    })
  }
}

const attributesAdd = async (item) => {
  if (isUnavailable(item.cartStatus)) return

  if (isCartsGuide.value) {
    return
  }
  if (item.skuQuantity < item.max) {
    item.skuQuantity += item.bundleQuantity
    updateProductSkuPrice(item)

    item.skuSubtotal =
      bankersRound(currencyData?.value.rate * item.skuPriceRmb, 2) *
      item.skuQuantity

    minOrderQuantity.value = item.batchNum
    await updateCarts({
      cartId: item.cartId,
      quantity: item.skuQuantity
    })
  }
}

// 捆绑数量算法
const calcBundleQuantity = (data) => {
  const bundleQuantity = +data.bundleQuantity
  const halfBundle = bundleQuantity / 2
  let quantity = +data.skuQuantity
  quantity = (Math.floor((quantity + halfBundle) / bundleQuantity)) * bundleQuantity
  if (quantity <= 0) {
    quantity = bundleQuantity
  }
  return quantity
}

const changeAttributes = async (item, index, e) => {
  if (isUnavailable(item.cartStatus)) return

  if (isCartsGuide.value) {
    return
  }
  item.skuQuantity = calcBundleQuantity(item)
  if (item.skuQuantity < item.min) {
    item.skuQuantity = item.min
  }
  if (item.skuQuantity > item.max) {
    item.skuQuantity = item.max
  }
  updateProductSkuPrice(item)
  item.skuSubtotal =
    bankersRound(currencyData?.value.rate * item.skuPriceRmb, 2) *
    item.skuQuantity

  minOrderQuantity.value = item.batchNum
  await updateCarts({
    cartId: item.cartId,
    quantity: item.skuQuantity
  })
}

const updateCarts = async (params) => {
  const { code } = await fetchData('/appb/b2b/cart/cartUpdate', {
    method: 'post',
    body: JSON.stringify(params)
  })

  if (code === 200) {
    store.dispatch('cart/updateCartCount')
  } else if (code === 100001) {
    showExceedQuantityDialog.value = true
  } else if (code === 200001) {
    $toast('Please fill delivery address.')
    localStorage.removeItem('addressForm')
    showAddressInfoDialog.value = true
  }
}

const totalPrice = computed(() => {
  let total = 0
  list.value.forEach((v) => {
    if (v.checked) {
      total += bankersRound(currencyData?.value.rate * v.skuPriceRmb, 2) * v.skuQuantity
    }
  })
  return total
})
const isCouponAvailable = computed(() => {
  if (coupon.value == null || currencyData.value == null) return false
  const minOrderAmount = exchangeCurrency(coupon.value.minOrderAmount, 'USD', currencyData.value.targetCurrency)
  return totalPrice.value >= minOrderAmount
})
const renderSubtotal = computed(() => {
  let total = totalPrice.value
  if (isCouponAvailable.value) {
    const targetDiscountAmount = exchangeCurrency(coupon.value.discountAmount, 'USD', currencyData.value?.targetCurrency)
    total -= targetDiscountAmount
  }
  return total.toFixed(2)
})

const handleBatchDelete = async () => {
  const checkedCartsItems = list.value
    .filter((item) => item.checked)
    ?.map((item) => item.cartId)
  try {
    const { code } = await fetchData('/appb/b2b/cart/cartDelete', {
      method: 'post',
      body: JSON.stringify({
        cartIds: checkedCartsItems
      })
    })
    if (code === 200) {
      $toast('Deleted successfully.', { type: 'success' })
      list.value = list.value.filter(
        (item) => !checkedCartsItems.includes(item.cartId)
      )

      fetchData('/appb/b2b/cart/cartCount').then((res) => {
        if (res.code === 200) {
          store.commit('cart/SET_CART_COUNT', res.data)
        }
      })
    }
  } catch (error) {
    console.log(error)
  }
}

const skip = () => {
  step.value = 1
  isCartsGuide.value = false
  localStorage.setItem('cartsGuide', 1)
}

const handleEdit = async (item) => {
  const { code } = await fetchData('/appb/b2b/cart/cartDelete', {
    method: 'post',
    body: JSON.stringify({
      cartIds: [item.cartId]
    })
  })
  if (code === 200) {
    $toast('Deleted successfully.', { type: 'success' })
    list.value = list.value.filter((v) => v.cartId !== item.cartId)

    fetchData('/appb/b2b/cart/cartCount').then((res) => {
      if (res.code === 200) {
        store.commit('cart/SET_CART_COUNT', res.data)
      }
    })
  }
}

const renderBatchDelete = computed(() => {
  return list.value.some((item) => item.checked)
})

const clickCount = ref(0)
const handleCheckout = async () => {
  gaAnalytics('PM_Checkout', 'PM_Checkout')
  if (isCartsGuide.value) {
    return
  }

  if (renderPendingProcessing.value) {
    showProcessingTips.value = true
    return
  }

  if (hasUnavailable.value) return

  buriedPointUtil({ eventId: 'MPC204' })

  clickCount.value++
  if (allowOrderSwitch.value === 0) {
    intercom.showNewMessage()
    return
  }
  const checkedCartsItems = list.value
    .filter((item) => item.checked)
    ?.map((item) => item.cartId)
  if (checkedCartsItems.length === 0) {
    $toast('Please select at least one item.', { type: 'error' })
    return
  }

  // 检查每个SPU是否满足最小批量
  const checkedItems = list.value.filter((item) => item.checked)
  const spuIds = [...new Set(checkedItems.map((item) => item.spuId))]

  for (const spuId of spuIds) {
    const batchNum = getSpuBatchNum(spuId)
    const quantity = getSpuQuantity(spuId)
    if (quantity < batchNum) {
      $toast('Please meet the minimum order quantity for all items.', { type: 'error' })
      return
    }
  }
  sessionStorage.setItem('carts', JSON.stringify(checkedCartsItems))
  buriedPointUtil({ eventId: 'MPC203' })
  router.push('/orderFilling')
}

const handleCopyLink = () => {
  copyText(whatsAppUrl.value).then(() => {
    $toast('Copy Successfully')
  })
}

const closeBtn = () => {
  const token = useUserStore().userInfo.tk
  if (!token) {
    router.replace('/')
    return
  }
  router.go(-1)
}
const handleCheck = (item) => {
  if (checkedTabIndex.value === 3) return

  if (list.value.filter((item) => item.checked).length >= 50 && !item.checked) {
    $toast('You can only select up to 50 items', { type: 'error' })
    return
  }

  const spuBatchNum = getSpuBatchNum(item.spuId)

  // 如果是取消勾选
  if (item.checked) {
    // 获取同一SPU下其他已勾选的SKU数量总和
    const otherCheckedQuantity = list.value
      .filter(v => v.spuId === item.spuId && v.checked && v.cartId !== item.cartId)
      .reduce((sum, v) => sum + v.skuQuantity, 0)

    // 如果还有其他已勾选的SKU,检查数量是否满足最小起批量
    if (otherCheckedQuantity > 0 && otherCheckedQuantity < spuBatchNum) {
      $toast(
        `The minimum order quantity of ${spuBatchNum} items has not been met.`,
        { type: 'error' }
      )
      return
    }
  }

  item.checked = !item.checked
  updateProductSkuPrice(item)
}

const handleSub = (item) => {
  if (isCartsGuide.value) {
    return
  }
  router.push(`/offer/${item.spuId}`)
}

const skipThirdPage = async () => {
  intercom.showNewMessage()
}

const isUnavailable = (status) => {
  return [50, 51, 52].includes(Number(status))
}

const subTotalColor = (status) => {
  if (status === 0) return '#db7e25'
  if (isUnavailable(status)) return '#6E717A'
  return '#052785'
}

const showExceedQuantityDialog = ref(false)

const minOrderQuantity = ref(0)

const handleCloseExceedQuantityDialog = async () => {
  showExceedQuantityDialog.value = false
  const { code, data } = await fetchData('/appb/b2b/cart/cartList?page=1&pageSize=200')

  if (code === 200) {
    let checkNum = 0
    list.value = data?.rows?.map((v) => {
      if ([0, 10].includes(v.cartStatus) && checkNum < 50) {
        v.checked = true
        checkNum++
      } else {
        v.checked = false
      }
      return {
        ...v,
        max: Infinity
      }
    })

    list.value.forEach(item => {
      updateProductSkuPrice(item)
      item.skuSubtotal = bankersRound(currencyData?.value.rate * item.skuPriceRmb, 2) * item.skuQuantity
    })
  }
}


const popVisible = ref(false)
const showAddressInfo = ref(false)
const currentCountry = ref(null)
const hiddenPop = () => {
  popVisible.value = false
  showAddressInfo.value = false
}

const getCountry = async () => {
  const { code, data } = await fetchData('/dsp-app/alibaba-common/country')
  if (code === 200) {
    store.commit('setCountryInfo', data)

    const countryObj = localStorage.getItem('setCurrentCountry')
      ? JSON.parse(localStorage.getItem('setCurrentCountry'))
      : data[0]
    store.commit('setCurrentCountry', countryObj)
    currentCountry.value = countryObj
  }
}

const onImageClick = (image) => {
  showImagePreview({
    images: [image]
  })
}
</script>

<style>
@import "./index.less";
</style>
